"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* eslint-disable camelcase */
const chart_donut_threshold_warning_Color_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_donut_threshold_warning_Color"));
const chart_donut_threshold_danger_Color_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_donut_threshold_danger_Color"));
// Donut utilization styles
exports.DonutUtilizationStyles = {
    thresholds: {
        colorScale: [chart_donut_threshold_warning_Color_1.default.value, chart_donut_threshold_danger_Color_1.default.value]
    }
};
//# sourceMappingURL=donut-utilization-styles.js.map